const Alert = styled.div`
  background-color: #DCEFC8;
  font-size: 13px;
  line-height: 16px;
  padding: 12px 15px;
  margin-bottom: 15px;
`

export default Alert
